import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Tooltip, Space, Typography, Input } from 'antd';
import { useEffect, useMemo } from 'react';

function CustomPasswordTooltip({
  value = '',
  onChange,
  placeholder,
  formData,
  datakey,
  setTooltipOpen,
  tooltipOpen
}) {
  const passwordRules = useMemo(
    () => [
      { key: 'upperCase', label: 'At least 1 uppercase letter', regex: /[A-Z]/ },
      { key: 'lowerCase', label: 'At least 1 lowercase letter', regex: /[a-z]/ },
      { key: 'number', label: 'At least 1 number', regex: /\d/ },
      { key: 'specialChar', label: 'At least 1 special character', regex: /[!@#$%^&*]/ },
      { key: 'length', label: 'At least 12 characters', regex: /.{12,}/ }
    ],
    []
  );

  const validations = useMemo(
    () =>
      passwordRules.reduce((acc, { key, regex }) => {
        acc[key] = regex.test(value);
        return acc;
      }, {}),
    [value, passwordRules]
  );

  const checkValidation = (passwordValue) => {
    const rulesObj = passwordRules.reduce((acc, { key, regex }) => {
      acc[key] = {
        value: passwordValue, // the value you typed
        isValid: regex.test(passwordValue) // rule check result
      };
      return acc;
    }, {});
    return !Object.values(rulesObj).every((rule) => rule?.isValid);
  };

  const handleChange = (val) => {
    onChange?.(val);
    if (checkValidation(val)) formData?.setFieldValue(datakey, val);
    setTooltipOpen(checkValidation(val));
  };

  useEffect(() => {
    if (value) setTooltipOpen(checkValidation(value));
  }, [value]);

  return (
    <Tooltip
      placement="rightTop"
      showArrow
      open={tooltipOpen}
      overlayInnerStyle={{
        backgroundColor: 'black',
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        padding: '8px 12px'
      }}
      // overlayStyle={{
      //   '--antd-arrow-background-color': '#fff',
      //   '--antd-arrow-shadow-color': 'rgba(214, 38, 38, 0.1)'
      // }}
      title={
        <div>
          <Space direction="vertical" size={6}>
            {passwordRules.map(({ key, label }) => (
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                {validations[key] ? (
                  <CheckCircleOutlined style={{ color: '#52c41a' }} />
                ) : (
                  <CloseCircleOutlined style={{ color: '#ff4d4f' }} />
                )}
                <Typography.Text style={{ color: '#fff', fontSize: 13 }}>{label}</Typography.Text>
              </div>
            ))}
          </Space>
        </div>
      }
    >
      <Input.Password
        style={{ width: '100%', padding: '12px' }}
        placeholder={placeholder}
        value={value}
        size="middle"
        onChange={(e) => handleChange(e.target.value)}
        autoComplete="off"
      />
    </Tooltip>
  );
}

CustomPasswordTooltip.defaultProps = {
  value: null,
  onChange: () => {}
};

CustomPasswordTooltip.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  datakey: PropTypes.string.isRequired,
  tooltipOpen: PropTypes.bool.isRequired,
  setTooltipOpen: PropTypes.func.isRequired
};

export default CustomPasswordTooltip;
